import { useEffect } from "react";
import { Modal } from "react-bootstrap"
import { useForm } from 'react-hook-form';
import { FormErrorMessage } from "../../components";
import { ApiSchemaLanguageData, ApiSchemaCreateLanguageData, ApiSchemaEditLanguageData } from '../../models/api/language';
import { ModalFooter } from "../Common";
import { useFunctionalityLanguage } from '../../pages/hooks/functionalityLanguage';
import { useState } from "react";
import { useFunctionalityExists } from "../../pages/hooks/functionalityExists";
import { PlatformType } from "../../models";
import { useFunctionalityInputChecker } from "../../pages/hooks/functionalityInputChecker";
import { InputFieldValidationErrorMessage } from "../../configs";
import { LanguageTermsInput } from ".";

type Props = {
  show: boolean,
  handleShow: (value: boolean) => void,
  dataToEdit?: ApiSchemaLanguageData,
  setDataToEdit?: (value?: ApiSchemaLanguageData) => void
}

export function ModalAddLanguage(props: Props): JSX.Element {
  const { show, handleShow, dataToEdit, setDataToEdit } = props;
  const { onAdd, editLanguage } = useFunctionalityLanguage({ plaformType: PlatformType.All });
  const { register, control, handleSubmit, formState: { errors }, watch } = useForm<ApiSchemaLanguageData>(
    {
      defaultValues: {
        id: dataToEdit?.id ?? "",
        name: dataToEdit?.name ?? "",
        code: dataToEdit?.code ?? "",
        pin: dataToEdit?.pin ?? "",
        languageSpokenTerms: [],
      },
      shouldUnregister: false,
    }
  );
  const [alertText, setAlertText] = useState<boolean>(false);
  const [languageNameErrMsg, setLanguageNameErrMsg] = useState("");
  const [codeExistsMsg, setCodeExistsMsg] = useState("");
  const [pinExistsMsg, setPinExistsMsg] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const { useFunctionlityInputFieldValidation } = useFunctionalityInputChecker();

  const { onLanguagePinExists, onLanguageCodeExists, onLanguageNameExists } = useFunctionalityExists();


  const onEdit = async (form: ApiSchemaEditLanguageData) => {
    const parentLanguageId =
      form.id?.trim() ||
      dataToEdit?.id?.trim() ||
      "";

    const lnameValue = (document.getElementById("name") as HTMLInputElement).value;
    const lcodeValue = (document.getElementById("code") as HTMLInputElement).value;
    const lpivalue = (document.getElementById("pin") as HTMLInputElement).value;

    const existingTerms = new Set(
      (dataToEdit?.languageSpokenTerms ?? [])
        .map(t => (t.term ?? "").trim().toLowerCase())
    );


    const newTermsOnly = (form.languageSpokenTerms ?? [])
      .map(x => ({ term: (x as any).term?.trim() ?? "" }))
      .filter(x => x.term.length > 0)
      .filter(x => !existingTerms.has(x.term.toLowerCase()))
      .reduce<{ term: string }[]>((acc, cur) => {
        const key = cur.term.toLowerCase();
        if (!acc.some(a => a.term.toLowerCase() === key)) acc.push(cur);
        return acc;
      }, [])
      .map(x => ({ term: x.term, languageId: parentLanguageId }));

    const payload: ApiSchemaEditLanguageData = {
      ...form,
      name: form.name.trim(),
      languageSpokenTerms: newTermsOnly,
    };

    const r = await onLanguageNameExists(lnameValue, dataToEdit);
    setLanguageNameErrMsg(r ? "Language Already Exists" : "");
    const rr = await onLanguagePinExists(lpivalue, dataToEdit);
    setPinExistsMsg(rr ? "Pin Already Exists" : "");
    const rrr = await onLanguageCodeExists(lcodeValue, dataToEdit);
    setCodeExistsMsg(rrr ? "Pin Already Exists" : "");

    if (!r && !rr && !rrr) {
      await editLanguage(payload, dataToEdit?.id ?? "");
      handleShow(false);
    }
  };


  useEffect(() => {
    console.log("dataToEdit:", dataToEdit)

  }, [dataToEdit]);

  const onSuccessLanguageAdd = async (form: ApiSchemaCreateLanguageData) => {
    const lname = document?.getElementById("name") as HTMLInputElement
    const lnameValue = lname.value
    const lCode = document.getElementById("code") as HTMLInputElement
    const lcodeValue = lCode.value
    const lpin = document.getElementById("pin") as HTMLInputElement
    const lpivalue = lpin.value
    form = {
      ...form,
      name: form.name.trim(),
      languageSpokenTerms: (form.languageSpokenTerms ?? []).map(({ term }) => ({ term })),

    }
    await onLanguageNameExists(lnameValue, dataToEdit)
      .then((r) => {
        onLanguagePinExists(lpivalue, dataToEdit)
          .then((rr) => {
            onLanguageCodeExists(lcodeValue, dataToEdit)
              .then((rrr) => {
                if (!r && !rr && !rrr) {
                  onAdd(form).then(() => {
                    handleShow(false);
                  }).catch((err) => {
                    console.error(err);
                  })
                }

              })
          })
      })
  }

  const pinInputValidation = (e: { target: { value: any; }; }) => {
    if (e.target.value.length == 1) {
      setAlertText(true)
    }
    else setAlertText(false)
  }

  const onPinExistValidation = async (value: any) => {
    await onLanguagePinExists(value, dataToEdit)
      .then((r) => {
        if (r) setPinExistsMsg("Pin Already Exists")
        else setPinExistsMsg("")
      })
  }

  const onCodeExistsValidation = async (value: any) => {
    await onLanguageCodeExists(value, dataToEdit)
      .then((r) => {
        if (r) setCodeExistsMsg("Code Already Exists")
        else setCodeExistsMsg("")
      })

  }

  const onLanguageNameValidation = async (value: any) => {
    await onLanguageNameExists(value, dataToEdit)
      .then((r) => {
        if (r) setLanguageNameErrMsg("Name Already Exists")
        else setLanguageNameErrMsg("")
      })
  }
  return (
    <Modal
      show={show}
      onHide={() => {
        setDataToEdit?.(undefined);
        handleShow(false);
      }}
      centered
    >
      <form onSubmit={handleSubmit(dataToEdit ? onEdit : onSuccessLanguageAdd)}>
        <Modal.Header closeButton>
          <Modal.Title className="test-modal" >{dataToEdit ? 'Edit Language' : 'Add Language'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <label htmlFor="" className="position-relative required">Language</label>
                <input
                  type="text"
                  {...register('name', { required: true, validate: useFunctionlityInputFieldValidation })}
                  className="form-control"
                  placeholder="Language"
                  id='name'
                  defaultValue={dataToEdit?.name}
                  onChange={(e) => { onLanguageNameValidation(e.target.value) }} />
                {errors.name?.type === "required" && (<FormErrorMessage message="required" />)}
                {languageNameErrMsg && (<FormErrorMessage message={languageNameErrMsg} />)}
                {errors.name && errors.name.type == "validate" && (<FormErrorMessage message={InputFieldValidationErrorMessage.ErrorMessage} />)}
              </div>
              <div className="form-group">
                <label htmlFor="" className="position-relative required">Code</label>
                <input
                  type="text"
                  {...register('code', { required: true })}
                  className="form-control"
                  placeholder="Code"
                  id='code'
                  defaultValue={dataToEdit?.code}
                  onChange={(e) => { onCodeExistsValidation(e.target.value) }} />
                {codeExistsMsg && (<FormErrorMessage message={codeExistsMsg} />)}
                {errors.code?.type === "required" && (<FormErrorMessage message="required" />)}
              </div>
              <div className="form-group">
                <label htmlFor="" className="position-relative required">PIN</label>
                <input

                  type="text"
                  {...register('pin', {
                    required: true,
                    pattern: /^[0-9]{2,4}$/,
                    onChange: (e) => {
                      pinInputValidation(e);
                      onPinExistValidation(e.target.value);
                    }
                  })}
                  className="form-control"
                  placeholder="Enter PIN. (Min 2 digits, Max 4 digits)"
                  minLength={2}
                  maxLength={4}
                  id='pin'
                  defaultValue={dataToEdit?.pin} />
                {errors.pin?.type === "required" && (<FormErrorMessage message="required" />)}
                {errors.pin?.type === "pattern" && (<FormErrorMessage message="PIN must be 2-4 digits and contain only numbers" />)}
                {pinExistsMsg && (<FormErrorMessage message={pinExistsMsg} />)}
                {alertText && <span className="form-text m-b-none text-start ps-1 text-danger"  >Please enter at least 2 characters.</span>}
              </div>

              <LanguageTermsInput
                control={control}
                name="languageSpokenTerms"
                languageId={watch("id")}
                required={false}
                error={errors.languageSpokenTerms as any}
                label="Spoken Terms"
                placeholder="Type a term and press Enter…"
                minTermLen={2}
                initialExistingTerms={dataToEdit?.languageSpokenTerms ?? []}
              />


            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <ModalFooter handleShow={handleShow} setDataToEdit={setDataToEdit} handleSubmit={handleSubmit} disbaled={buttonDisabled} operationName={dataToEdit ? "Update" : ""} />
        </Modal.Footer>
      </form>
    </Modal>
  );
}